import { render, staticRenderFns } from "./ImageUploadButton.vue?vue&type=template&id=120276fd&scoped=true&"
import script from "./ImageUploadButton.vue?vue&type=script&lang=js&"
export * from "./ImageUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadButton.vue?vue&type=style&index=0&id=120276fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120276fd",
  null
  
)

export default component.exports